<div class="dashbaord-footer">
  <div class="row" *ngIf="false">
    <div class="col-sm-12 col-lg-6">
      <div fxLayout="column" fxLayoutAlign="center center">
        <p class="mb-3">Open items requiring your attention</p>
        <div class="btns w-75" fxLayout="row" fxLayoutAlign="space-around">
          <button mat-raised-button>1. DROP</button>
          <button mat-raised-button>2. A&A</button>
          <button mat-raised-button>3. OTHER</button>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-lg-6">
      <div fxLayout="column" fxLayoutAlign="center center">
        <p class="mb-3">Click here for:</p>
        <div class="btns w-75" fxLayout="row" fxLayoutAlign="space-around">
          <button mat-raised-button>CLOSED DEAL REPORTS</button>
          <button mat-raised-button>COMMISSION REPORTS</button>
        </div>
      </div>
    </div>
  </div>
</div>
